import { RouteObject } from 'react-router-dom';

import { PATH } from '~/constants/route-path';
import FacebookEmail from '~/pages/FacebookEmail';
import SignIn from '~/pages/SignIn';
import SignUp from '~/pages/SignUp';
import GuestRoute from '~/routes/GuestRoute';

const LOGIN_ROUTES: RouteObject[] = [
  {
    path: PATH.LOGIN,
    element: (
      <GuestRoute>
        <SignIn />
      </GuestRoute>
    ),
  },
  {
    path: PATH.SIGN_UP,
    element: (
      <GuestRoute>
        <SignUp />
      </GuestRoute>
    ),
  },
  {
    path: PATH.FACEBOOK_LOGIN,
    element: (
      <GuestRoute>
        <FacebookEmail />
      </GuestRoute>
    ),
  },
];

export { LOGIN_ROUTES };
